import { computed, ref, useContext, useRoute } from '@nuxtjs/composition-api';

const SHOPS_LIMIT = 15;

const useShopsCenter = () => {
  const {
    i18n,
    $axios,
    $api: { shopsService, countriesService },
  } = useContext();
  const countries = ref([]);
  const isLoadingShops = ref(false);
  const isLoadingCountries = ref(false);
  const isCheckingCountry = ref(false);
  const route = useRoute();
  const currentPage = computed(() =>
    !route.value.query.page ? route.value.query.page : +route.value.query.page
  );
  const totalPagesCount = ref(null);
  const currentCountry = ref(null);
  const shops = ref([]);
  const isNoShopsInCurrentCountry = ref(false);

  const resetShops = () => {
    shops.value = [];
  };

  const isLoading = computed(
    () =>
      isLoadingShops.value ||
      isLoadingCountries.value ||
      isCheckingCountry.value
  );

  const fetchCountries = async () => {
    isLoadingCountries.value = true;
    try {
      const { data: countryIds } = await shopsService.getShopsCountriesIds();
      const { data: countriesData } = await countriesService.getCountriesByIds({
        country_id: countryIds.map((country) => country.id),
        limit: 1000,
      });
      countries.value = countriesData;
    } finally {
      isLoadingCountries.value = false;
    }
  };

  const filterShops = (data) => {
    shops.value = data
      ?.map((item) => {
        return item?.addresses?.map((address) => ({
          name: item.name,
          address: address.address,
          phones: address.phone,
          emails: address.email,
          url: address.url,
          shopID: item.id,
        }));
      })
      .flat();
  };

  const fetchShops = async () => {
    if (isNoShopsInCurrentCountry.value) return;

    isLoadingShops.value = true;
    try {
      const { data, meta } = await shopsService.getAllShops({
        page: currentPage.value,
        limit: SHOPS_LIMIT,
        search: `addresses.country_id:${currentCountry.value.id}`,
      });
      filterShops(data);

      totalPagesCount.value = meta.last_page;
    } finally {
      isLoadingShops.value = false;
    }
  };

  const checkUserCountry = async () => {
    isCheckingCountry.value = true;
    try {
      const { data } = await $axios.get(
        `https://pro.ip-api.com/json/?key=GQrQqBi9GuDpHMT&lang=${i18n.locale}`
      );

      currentCountry.value = countries.value.find(
        (c) => c.iso2 === data.countryCode
      );
      if (!currentCountry.value) {
        isNoShopsInCurrentCountry.value = true;
        currentCountry.value = {
          name: data.country,
          iso2: data.countryCode,
        };
      }
    } catch (_) {
      currentCountry.value = { ...countries.value[0] };
    } finally {
      isCheckingCountry.value = false;
    }
  };

  return {
    shops,
    countries,
    isLoading,
    isLoadingShops,
    isLoadingCountries,
    currentPage,
    totalPagesCount,
    currentCountry,
    isNoShopsInCurrentCountry,
    fetchCountries,
    fetchShops,
    resetShops,
    checkUserCountry,
  };
};

export default useShopsCenter;
